module.exports = __webpack_public_path__ + "static/media/user2.43a55cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/user2.png
// module id = 249
// module chunks = 0